import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import { ApiError, ExtendedApiResult } from 'common/repositories/common.model';

import { getSaleListInput, SaleListModel } from './model';

export function useGetSalesLists(
  input?: getSaleListInput,
  options?: UseQueryOptions<ExtendedApiResult<SaleListModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<SaleListModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['getSales', input?.params],
      () =>
        QueryFetchFunction({
          url: `tours/${input?.tourId}/get-sales`,
          params: input?.params,
        }),
      options,
    ),
    SaleListModel,
  );
}
